import {SubAPI} from "./SubAPI";
import {Paginated} from "./Users";

export class QuotePriceSectionNotes extends SubAPI {
    list(props: {
        project: number
        alternative: number
        offset: number;
    }) {
        return this.fetcher.get<Paginated<PriceSectionNote>>("/api/quote-price-section-notes", props)
    }

    upsert(props: Partial<PriceSectionNote>) {
        return this.fetcher.post<PriceSectionNote>("/api/quote-price-section-note", props)
    }
}

export type PriceSectionNote = {
    id: number;
    project: number;
    quoteAlternative: number;

    keyName: string;
    note: string;

    backup?: PriceSectionNote|null;
}

export type PriceSectionNoteDefault = {
    id: number;
    keyName: string;
    note: string;
}